import axios from "axios";
import type { UseFormSetError } from "react-hook-form";
import type { EditDriverFormValues } from "../schema";

export const handleEditDriverError = (
	err: unknown,
	setError: UseFormSetError<EditDriverFormValues>
) => {
	if (!axios.isAxiosError(err)) {
		return;
	}

	const detail = err.response?.data?.error?.detail;

	if (detail === "VehicleAlreadyAssignedToAnotherDriver") {
		setError("vehicleId", {
			type: "manual",
			message: "Este veículo já está vinculado a outro motorista.",
		});
		return;
	}

	if (detail === "CnhAlreadyInUse") {
		setError("cnh", {
			type: "manual",
			message: "Esta CNH já está vinculada a outro motorista.",
		});
		return;
	}

	if (detail?.includes("Veículo não encontrado")) {
		setError("vehicleId", {
			type: "manual",
			message: "Veículo não encontrado para a placa informada.",
		});
		return;
	}
};
